import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { BaseIcon, LockIcon, UnlockIcon } from "@/components/icons";
  import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LockedBiddingBtn',
  setup(__props) {

  const auctionStore = useAuctionStore();

  const isLockedBidding = computed(() => {
    return auctionStore.isLockedBidding;
  });
  const btnText = computed(() => {
    const isAdmin = auctionStore.user?.is_admin;

    if (isLockedBidding.value) {
      return trans("live.tabs.lock_unlock." + (isAdmin ? "unlock_btn_label" : "buyer_unlock_btn_label"));
    } else {
      return trans("live.tabs.lock_unlock." + (isAdmin ? "lock_btn_label" : "buyer_lock_btn_label"));
    }
  });

  const toggleLock = () => {
    auctionStore.$patch({
      isLockedBidding: !isLockedBidding.value
    });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: toggleLock,
    class: _normalizeClass([
      'btn',
      'btn-lock-bidding',
      { locked: isLockedBidding.value },
      { 'btn-blue': !isLockedBidding.value },
      { 'btn-blue-outline': isLockedBidding.value }
    ])
  }, [
    _createTextVNode(_toDisplayString(btnText.value) + " ", 1),
    (isLockedBidding.value)
      ? (_openBlock(), _createBlock(_unref(BaseIcon), {
          key: 0,
          "icon-name": "lock",
          "view-box": "0 0 17.721 23.259"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(LockIcon))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_unref(BaseIcon), {
          key: 1,
          "icon-name": "unlock",
          "view-box": "0 0 18 24"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UnlockIcon))
          ]),
          _: 1
        }))
  ], 2))
}
}

})